import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import { mapState, mapActions } from 'vuex'
import constants from '@/util/constants'
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
import util from '@/util'

export default {
  name: 'advogado',
  components: {
    'default-table': defaultTable
  },

  computed: {
    ...mapState('usuarios', ['listaUnidadesDisponiveis', 'listaCoordenadoresDisponiveis', 'listaCapasDisponiveis', 'listaTiposDeAcaoDisponiveis', 'dadosPerfil', 'dadosRetorno', 'flagsDeControle'])
  },

  data: () => {
    return {
      timeOutDigitacaoNocombo: null,
      comboUnidadesDisponiveis: [],
      comboCoordenadoresDisponiveis: [],

      comboCapasDisponiveis: [],
      capaSelecionada: null,
      fieldsCapa: [
        { key: 'f_name', sortable: false, label: 'Nome' },
        { key: 'opcoes', sortable: false, label: 'Opções' }
      ],

      comboTiposAcaoDisponiveis: [],
      opcaoSelecionadaComboAcoes: null,
      idOpcaoComboAcoes: null,
      fieldsTiposAcao: [
        { key: 'f_actiontype_name', sortable: false, label: 'Nome' },
        { key: 'opcoes', sortable: false, label: 'Opções' }
      ],
      fieldsQuemMeVisualiza: [
        { key: 'f_name', sortable: false, label: 'Nome' }
      ],
      codigoDaOpcaoTodosNoComboDeCapas: 0
    }
  },

  mounted () {
    this.limparListaErros()
    this.obterCoordenadoresDisponiveis()
    this.obterCapasDisponiveis()
  },

  methods: {
    ...mapActions('usuarios', ['ActionDefinirListaUnidades', 'ActionDefinirListaCoordenadores', 'ActionDefinirListaCapas', 'ActionDefinirListaTiposAcao', 'ActionResetarListaTiposAcao']),

    tabelaSemRegistros (item, type) {
      if (util.valorVazio(item) && type === 'row-empty') {
        return 'text-center'
      }
    },

    eventoDigitarBuscaPorCoordenador (valorDigitadoParaBusca, callbackFlagCarregamento) {
      clearTimeout(this.timeOutDigitacaoNocombo)
      let referenciaObjetoDaView = this

      this.timeOutDigitacaoNocombo = setTimeout(function () {
        referenciaObjetoDaView.obterCoordenadoresDisponiveis(valorDigitadoParaBusca, callbackFlagCarregamento)
      }, constants.tempoParaAguardarDigitacaoNoCombo)
    },

    async obterCoordenadoresDisponiveis (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }

      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'f_name': valorDigitadoParaBusca }
      }
      await this.ActionDefinirListaCoordenadores(parametrosRequisicao)
      this.comboCoordenadoresDisponiveis = this.listaCoordenadoresDisponiveis.map(function (registro) {
        return { label: registro.user.f_name, code: registro.f_id }
      })
      callbackFlagCarregamento = false
    },

    eventoDigitarBuscaPorCapa (valorDigitadoParaBusca, callbackFlagCarregamento) {
      this.limparListaErros()

      clearTimeout(this.timeOutDigitacaoNocombo)
      let referenciaObjetoDaView = this

      this.timeOutDigitacaoNocombo = setTimeout(function () {
        referenciaObjetoDaView.obterCapasDisponiveis(valorDigitadoParaBusca, callbackFlagCarregamento)
      }, constants.tempoParaAguardarDigitacaoNoCombo)
    },

    async obterCapasDisponiveis (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }
      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'f_name': valorDigitadoParaBusca }
      }

      await this.ActionDefinirListaCapas(parametrosRequisicao)
      this.comboCapasDisponiveis = this.listaCapasDisponiveis.map(function (registro) {
        return { label: registro.user.f_name, code: registro.user.f_id }
      })
      if (!util.valorVazio(this.comboCapasDisponiveis)) {
        this.comboCapasDisponiveis.unshift({ label: 'Todos', code: 0 })
      }
      callbackFlagCarregamento = false
    },

    adicionarNaListagemDeCapas () {
      this.limparListaErros()

      if (util.valorEhNulo(this.capaSelecionada)) {
        this.dadosRetorno.listaDeErros['f_profile_data.f_capas'] = 'Selecione uma capa'
        this.resetarCamposDeCapas()
      } else {
        const temCapa = this.dadosPerfil.f_capas.some((capa) => capa.f_view === this.capaSelecionada.code)
        if (temCapa) {
          this.dadosRetorno.listaDeErros['f_profile_data.f_capas'] = 'Esta capa já foi adicionada'
        } else {
          this.adicionarCapasNaLista()
        }
      }
      this.resetarCamposDeCapas()
    },

    adicionarCapasNaLista () {
      if (this.capaSelecionada.code === this.codigoDaOpcaoTodosNoComboDeCapas) {
        this.adicionarTodasAsCapas()
      } else {
        this.adicionarUmaCapa(this.capaSelecionada)
      }
    },

    adicionarTodasAsCapas () {
      const listaDeTodasAsCapas = this.comboCapasDisponiveis
      for (const indice in listaDeTodasAsCapas) {
        const capa = listaDeTodasAsCapas[indice]
        const temCapa = this.dadosPerfil.f_capas.some((capaDaLista) => capaDaLista.f_view === capa.code)
        const naoEhcodigoTodasCapas = capa.code !== this.codigoDaOpcaoTodosNoComboDeCapas
        if (!temCapa && naoEhcodigoTodasCapas) {
          this.adicionarUmaCapa(capa)
        }
      }
    },

    adicionarUmaCapa (capa) {
      const obj = {
        'f_view': capa.code,
        'f_name': capa.label
      }
      this.dadosPerfil.f_capas.push(obj)
    },

    excluirDaListagemDeCapas (item) {
      const indice = this.dadosPerfil.f_capas.map(
        function (elemento) {
          return elemento.f_view
        }).indexOf(item.f_view)
      if (indice !== -1) {
        this.dadosPerfil.f_capas.splice(indice, 1)
      }
    },

    resetarCamposDeCapas () {
      this.capaSelecionada = null
    },

    eventoDigitarBuscaPorTiposAcao (objetoCombo) {
      if (objetoCombo.searchQuery.trim().length >= 3) {
        if (objetoCombo.action === ASYNC_SEARCH) {
          this.ActionResetarListaTiposAcao()
          clearTimeout(this.timeOutDigitacaoNocombo)
          let referenciaObjetoDaView = this
          this.timeOutDigitacaoNocombo = setTimeout(function () {
            referenciaObjetoDaView.executarBuscaPorTiposAcao(objetoCombo)
          }, constants.tempoParaAguardarDigitacaoNoCombo)
        }
      } else {
        objetoCombo.callback(null, {})
      }
    },

    async executarBuscaPorTiposAcao (objetoCombo) {
      let valorDigitadoParaBusca = objetoCombo.searchQuery
      this.limparListaErros()
      await this.obterTiposAcaoDisponiveis(valorDigitadoParaBusca)
      objetoCombo.callback(null, this.comboTiposAcaoDisponiveis)
    },

    async obterTiposAcaoDisponiveis (valorDigitadoParaBusca) {
      let parametrosRequisicao = {
        'registrosPorPagina': constants.defaultRegistrosCombo,
        'filtros': { 'f_name': valorDigitadoParaBusca }
      }
      await this.ActionDefinirListaTiposAcao(parametrosRequisicao)
      this.popularComboTiposDeAcao()
    },

    popularComboTiposDeAcao () {
      const listaAreas = this.listaTiposDeAcaoDisponiveis
      this.comboTiposAcaoDisponiveis = []
      for (const idArea in listaAreas) {
        const area = listaAreas[idArea]
        const listaAcoes = area.f_action
        const objetoArea = this.montarAreaParaComboTiposAcao(area)
        for (const indice in listaAcoes) {
          const acao = listaAcoes[indice]
          const objetoAcao = this.montarAcaoParaComboTiposAcao(area, acao)
          objetoArea.children.push(objetoAcao)
        }
        this.comboTiposAcaoDisponiveis.push(objetoArea)
      }
    },

    montarAreaParaComboTiposAcao (area) {
      const objetoArea = {
        id: area.f_id,
        label: area.f_name,
        children: []
      }
      return objetoArea
    },

    montarAcaoParaComboTiposAcao (area, acao) {
      const nomeArea = area.f_name
      const nomeAcao = '[' + nomeArea + '] ' + acao.f_name
      const objetoAcao = {
        id: acao.f_id,
        idArea: area.f_id,
        label: nomeAcao
      }
      return objetoAcao
    },

    selecionarOpcaoComboAcoes (nodo) {
      this.opcaoSelecionadaComboAcoes = nodo
    },

    adicionarNaListagemDeTiposAcao () {
      this.limparListaErros()

      if (util.valorEhNulo(this.idOpcaoComboAcoes)) {
        this.dadosRetorno.listaDeErros['f_profile_data'] = 'Selecione um tipo de ação'
        this.resetarCamposDeTiposAcao()
      } else {
        this.adicionarTiposAcaoNaLista()
      }
      this.resetarCamposDeTiposAcao()
    },

    adicionarTiposAcaoNaLista () {
      if (util.valorEhNulo(this.opcaoSelecionadaComboAcoes.children)) {
        const temTipoAcao = this.validarInsercaoDeAcaoNaLista(this.opcaoSelecionadaComboAcoes)
        if (!temTipoAcao) {
          this.inserirTiposAcaoNaLista(this.opcaoSelecionadaComboAcoes)
        }
      } else {
        const listaDeAcoesDaAreaSelecionada = this.opcaoSelecionadaComboAcoes.children
        for (const indice in listaDeAcoesDaAreaSelecionada) {
          const acao = listaDeAcoesDaAreaSelecionada[indice]
          const temTipoAcao = this.validarInsercaoDeAcaoNaLista(acao)
          if (!temTipoAcao) {
            this.inserirTiposAcaoNaLista(acao)
          }
        }
      }
    },

    validarInsercaoDeAcaoNaLista (acao) {
      return this.dadosPerfil.f_actiontypes.some((tipoAcaoDaLista) => tipoAcaoDaLista.f_actiontype === acao.id)
    },

    inserirTiposAcaoNaLista (objSelecionado) {
      const obj = {
        'f_actiontype': objSelecionado.id,
        'f_area_id': objSelecionado.idArea,
        'f_area_name': '[]',
        'f_actiontype_name': objSelecionado.label
      }
      this.dadosPerfil.f_actiontypes.push(obj)
    },

    excluirDaListagemDeTiposAcao (item) {
      const indice = this.dadosPerfil.f_actiontypes.map(
        function (elemento) {
          return elemento.f_actiontype
        }).indexOf(item.f_actiontype)
      if (indice !== -1) {
        this.dadosPerfil.f_actiontypes.splice(indice, 1)
      }
    },

    resetarCamposDeTiposAcao () {
      this.opcaoSelecionadaComboAcoes = null
      this.idOpcaoComboAcoes = null
    },

    limparListaErros () {
      this.dadosRetorno.listaDeErros = {}
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    }
  }
}
